// extracted by css-extract-rspack-plugin
export default {"modal":"modal--fYVJwTyMjESRZiWc","modalContent":"modal-content--TDO_LwJg7Y85aTNt"};